// extracted by mini-css-extract-plugin
var _1 = "h5HvA";
var _2 = "PpB0g";
export { _1 as "button", _2 as "externalLinkIcon" }
